import * as Sentry from "@sentry/react";
import React from "react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

Sentry.init({
  dsn:
    (typeof window !== "undefined" &&
      (window as unknown as Record<string, unknown>).__SENTRY_DSN_OVERRIDE__) ||
    import.meta.env.VITE_SENTRY_DSN,
  // Forensic Tunneling: Use proxy only in dev (to bypass blockers).
  // In production (Cloudflare), we use direct DSN to avoid 404s on unconfigured proxy paths.
  tunnel: import.meta.env.DEV ? "/sentry-tunnel" : undefined,
  integrations: [
    Sentry.browserTracingIntegration(),
    // Native React Router v7 Alignment
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
    Sentry.browserProfilingIntegration(),
  ],

  // Performance Monitoring
  tracesSampleRate: 1.0,
  tracePropagationTargets: [
    "localhost",
    /^\//,
    /^https:\/\/htqmmjbfgavnivwousxw\.supabase\.co/,
  ],

  // High-Resolution Profiling
  profilesSampleRate: 1.0,

  // Session Replay
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,

  enabled:
    import.meta.env.PROD ||
    (typeof window !== "undefined" &&
      !!(window as unknown as Record<string, unknown>)
        .__SENTRY_DSN_OVERRIDE__) ||
    (!!import.meta.env.VITE_SENTRY_DSN &&
      import.meta.env.VITE_SENTRY_DSN.includes("dummy")),
  environment: import.meta.env.MODE,
  release: `krude-booking@${import.meta.env.VITE_APP_VERSION || "0.0.0"}`,
  sendDefaultPii: true,
  enableLogs: true,
  debug: true,
});
